import {
  Component,
  OnInit,
  WritableSignal,
  signal
} from '@angular/core';
import { OfficeService } from '@cai-services';
import { Office, SessionService } from '../../core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

@Component({
  selector: 'kt-office-text-selector',
  templateUrl: './office-text-selector.component.html',
  styleUrl: './office-text-selector.component.scss',
  standalone: false,
})
export class OfficeTextSelectorComponent implements OnInit {
  protected officeControl = new FormControl('');
  protected officeResults: WritableSignal<Office[]> = signal([]);
  protected iataCassQuery$ = new Subject<string>();

  constructor(
    private readonly officeService: OfficeService,
    private readonly sessionService: SessionService,
  ) {}
  
  ngOnInit(): void {
    this.iataCassQuery$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
    ).subscribe(iataCass => this.fetchOfficeResults(iataCass));

    const searchOffice = this.sessionService.getSearchOffice();
    if (searchOffice && (searchOffice.iata || searchOffice.cass)) {
      this.officeControl.setValue(searchOffice.id.toString());
      this.iataCassQuery$.next(this.getIataCass(searchOffice));
    }

    this.officeControl.valueChanges.subscribe((officeId: string) => {
      const selectedOffice = this.officeResults().find(office => office.id === +officeId);
      this.sessionService.setSearchOffice(selectedOffice);
    });
  }

  protected async fetchOfficeResults(iataCass: string): Promise<void> {
    if (iataCass?.length > 0) {
      this.officeResults.set(await this.officeService.searchForwarderOfficesByIataCass(
        iataCass.replace('-', ''),
      ) as Office[]);
    } else {
      this.officeResults.set([]);
    }
  }

  protected getIataCass(office: Office): string {
    if (office?.iata && office?.cass) {
      return office.iata + '-' + office.cass;
    } else if (office?.iata) {
      return office.iata
    }
    return '';
  }

  protected displayFn(officeId: string): string {
    const searchOffice = this.sessionService.getSearchOffice();
    if (searchOffice.id === +officeId) {
      return this.getIataCass(searchOffice);
    }
    const selectedOffice = this.officeResults().find(office => office.id === +officeId);
    return this.getIataCass(selectedOffice);
  }
}
